"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    network: 'mainnet',
    address: {
        empty: '0x0000000000000000000000000000000000000000',
        call: '0xFb6A63ed231d7787a9286034f1f986FbcDB5911a'
    },
    decimals: 18,
    host: {
        image: 'https://s3.ap-northeast-2.amazonaws.com/bifi.finance/',
        uniswap: 'https://api.thegraph.com/subgraphs/name/uniswap/uniswap-v2',
        sushiswap: 'https://api.thegraph.com/subgraphs/name/sushiswap/exchange'
    },
    callBody: {
        method: 'post',
        url: '',
        data: {
            id: 1,
            jsonrpc: '2.0',
            method: 'eth_call',
            params: []
        }
    },
    callParams: {
        from: '0x0',
        to: '0x0',
        data: '0x0',
        value: '0x0'
    }
};
//# sourceMappingURL=default.js.map